<template lang="pug">
  .button.text-truncate(:class="classes", @click="$emit('click')") {{ title || 'Botón sin título' }}
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    add: {
      type: Boolean,
      default: false
    },
    quickReply: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      maxLength: 20
    }
  },
  computed: {
    classes () {
      let obj = {}
      obj['text-help'] = !this.title
      obj['text-danger'] = this.title && this.title.length && this.title.length > this.maxLength
      obj['add'] = this.add != undefined ? Boolean(this.add) : false
      obj['not-draggable'] = this.add != undefined ? Boolean(this.add) : false
      obj['quick-reply'] = this.quickReply != undefined ? Boolean(this.quickReply): false
      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .button {
    display: block;
    width: 100%;
    border-radius: 10px;
    background-color: $light-white;
    color: $dark;
    text-align: center;
    padding: 7px 28px;
    position: relative;

    &.quick-reply {
      display: inline-block;
      width: auto;
      border-radius: 2rem;
    }

    &.add {
      border: 1.5px dashed $light-primary;
      background-color: transparent;
      color: $light-primary !important;
      cursor: pointer;
    }

    &:not(:last-child) {
      margin-bottom: .5rem;
    }
  }
</style>
